import { useAuthContext } from "./useAuth";

export function useAdminAccess() {
  const { userAdditionalData, userAdditionalDataIsLoading } = useAuthContext();

  return {
    isAdmin: userAdditionalData?.type === "admin",
    isAdminLoading: userAdditionalDataIsLoading,
  };
}
